import React from 'react';
import { Container } from './styles';

interface CheckoutCardProps {
  serviceName: string;
  serviceDescription: string;
  namePlan: string;
  valuePlan: number;
  baseValue: number;
  finalValue: number;
  parcela: number;
  text: string;
}

const CheckoutCard = (props: CheckoutCardProps) => {
  const {
    serviceName,
    serviceDescription,
    namePlan,
    valuePlan,
    baseValue,
    finalValue,
    parcela,
    text,
  } = props;

  return (
    <Container>
      <div className="col-md-12 p-0">
        <div className="card border border-success">
          <div className="row">
            <div className="col-md-8">
              <div className="card-body">
                <h5 className="font-weight-bold title">{serviceName}</h5>
                <p className="subtitle">{serviceDescription}</p>
                <p className="subtitle-2">
                  {text} O valor desse serviço para o plano {namePlan} é de{' '}
                  {Number(valuePlan).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </p>
              </div>
            </div>
            <div className="col-md-4 card-value p-2">
              <p className="value">
                {baseValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
              <p className="value-info ml-3">no boleto à vista ou</p>
              <p className="value">
                {finalValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
              <p className="value-info ml-3 mb-0">até {parcela}x sem juros no cartão</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default CheckoutCard;
